/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "fpa",
            "endpoint": "https://otqs61nlib.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "grower6040api",
            "endpoint": "https://ce5jkxqmhk.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "growersnosql",
            "endpoint": "https://psgkb0x6pd.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "rackbuslogic",
            "endpoint": "https://hebo25qg1k.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "scheduleAApi",
            "endpoint": "https://we3g6y1ra9.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:e8dfa261-5121-47aa-83b1-d50bd1857045",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_iexuP5J68",
    "aws_user_pools_web_client_id": "3d4qocedmhmqsqkirrckkv3nmm",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "rack-documents172829-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "fpas-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "grower6040-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "growers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "pricing-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ScheduleA-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
